import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';

const WhyChooseUsSection = () => {
  const { t } = useTranslation();
  
  const features = [
    { title: t('whyChooseUs.features.f1.title'), body: t('whyChooseUs.features.f1.body') },
    { title: t('whyChooseUs.features.f2.title'), body: t('whyChooseUs.features.f2.body') },
    { title: t('whyChooseUs.features.f3.title'), body: t('whyChooseUs.features.f3.body') },
    { title: t('whyChooseUs.features.f4.title'), body: t('whyChooseUs.features.f4.body') },
    { title: t('whyChooseUs.features.f5.title'), body: t('whyChooseUs.features.f5.body') },
    { title: t('whyChooseUs.features.f6.title'), body: t('whyChooseUs.features.f6.body') }
  ];

  return (
    <section className="section-spacing-large bg-cream">
      <div className="container-cift">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Content */}
          <div>
            <div className="gold-accent mb-6" />
            <h2 className="section-title mb-6">
              {t('whyChooseUs.headline')}
            </h2>
            <p className="body-text mb-8">
              {t('whyChooseUs.body')}
            </p>

            {/* Features List */}
            <div className="space-y-6">
              {features.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center">
                    <Check className="text-gold" size={18} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {item.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Image Grid */}
          <div className="grid grid-cols-1 gap-4 max-w-md mx-auto">
            <div className="aspect-square overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/qn8k4p10_Neueste%20Fotos%20anzeigen.jpg"
                alt="Videography Work"
                className="image-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="aspect-square overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/o472ph6u_DSC04114.jpeg"
                alt="Business Portrait"
                className="image-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
